<template>

  <div class="buttons">
    <a class="button1" :href="`tel:${data.phone}`">
      <div class="icon"><img src="../../assets/img/phone-icon.png" alt="Call me"/></div>
      <div class="copy">Call me</div>
      <div class="clear" />
    </a>

    <a class="button2" :href="`sms:${data.text}`">
      <div class="icon"><img src="../../assets/img/text-icon.png" alt="Text me" /></div>
      <div class="copy">Text me</div>
      <div class="clear" />
    </a>

    <div class="clear"></div>

    <a class="button3" :href="`mailto:${data.email}`" target="_blank" rel="noopener norefferer">
      <div class="icon"><img src="../../assets/img/email-icon.png" alt="Email me"/></div>
      <div class="copy">Email me</div>
      <div class="clear" />
    </a>

    <a :href="`${data.brochure}`" target="_blank">
      <div class="button4">
        <div class="icon"><img src="../../assets/img/brochure.png" alt="Brochure"/></div>
        <div class="copy">My brochure</div>
        <div class="clear" />
      </div>
    </a>

   	<div class="clear" />
    
    <a href="assets/files/card.vcf" target="_blank" rel="noopener norefferer" download>
      <div class="button5 active">
        <div class="icon"><img src="../../assets/img/download-icon.png" alt="Download Card"/></div>
        <div class="copy">Download</div>
        <div class="clear" />
      </div>
    </a>  

    <div id="sendModalBtn" @click="$emit('trigger-modal')">
      <div class="button6 active">
        <div class="icon"><img src="../../assets/img/send-icon.png" alt="Send"/></div>
        <div class="copy">Send</div>
        <div class="clear" />
      </div>
  	</div>

    <div class="clear" />
  </div>
  
</template>

<script>
  import data from '../../assets/data'

  export default {
	  name: 'Buttons',
    data: () => {
      return {
        data
      }
    },     
    props: {
      msg: String
    }
  }
</script>

<style scoped lang="scss">
</style>
